import NecOfficesPage from "./pages/NecOfficesPage";
import NecOfficeDetailsPage from "./pages/NecOfficeDetailsPage";

export const necOfficeRoutes = [
  {
    path: "/nec-offices",
    element: <NecOfficesPage />,
    roles: ["admin", "executive", "chairman", "secretary"],
  },
  {
    path: "/nec-offices/:id",
    element: <NecOfficeDetailsPage />,
    roles: ["admin", "executive", "chairman", "secretary"],
  },
];
